import { render, staticRenderFns } from "./export-data-order.vue?vue&type=template&id=627f497a&scoped=true&"
import script from "./export-data-order.vue?vue&type=script&lang=js&"
export * from "./export-data-order.vue?vue&type=script&lang=js&"
import style0 from "./export-data-order.vue?vue&type=style&index=0&id=627f497a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627f497a",
  null
  
)

export default component.exports